// extracted by mini-css-extract-plugin
export default {"songName":"SongName_songName__soHsF","nameText":"SongName_nameText__bmQTH"};